import React from 'react';

import {
  FEATURE_GATES,
  PermissionFilter,
  GlobalFeatureGateFilter
} from '@ubisend/pulse-auth';
import {
  Panel,
  PageWrapper
} from '@ubisend/pulse-components';

import { SharePoint } from '../Components';

const SharePointPage = () => (
  <PageWrapper beta="true" header="SharePoint" subheader="Configure your SharePoint">
    <GlobalFeatureGateFilter for={FEATURE_GATES.GENERATIVE_AI}>
      <GlobalFeatureGateFilter for={FEATURE_GATES.GENERATIVE_AI_SHAREPOINT}>
        <PermissionFilter can="view generative ai resource">
          <Panel>
            <SharePoint />
          </Panel>
        </PermissionFilter>
      </GlobalFeatureGateFilter>
    </GlobalFeatureGateFilter>
  </PageWrapper>
);

export default SharePointPage;